<template>
  <div class="relative w-full lg:h-[70vh] h-[30vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/hero-banner.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        About Us
      </h2>
    </div>
  </div>

  <!-- What makes us different -->
  <div class="bg-white py-16 px-4 md:px-12">
    <div
      class="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10"
    >
      <!-- Images Grid -->
      <div class="flex flex-col gap-6 w-full lg:w-1/2">
        <div class="rounded-xl overflow-hidden shadow-md">
          <img
            src="../assets/images/Subsidaries Head.png"
            alt="Team Meeting"
            class="w-full h-auto object-cover"
          />
        </div>
        <div class="grid grid-cols-2 gap-6">
          <div class="rounded-xl overflow-hidden shadow-md">
            <img
              src="../assets/images/Construction_12.jpg"
              alt="Whiteboard Session"
              class="w-full h-auto object-cover"
            />
          </div>
          <div class="rounded-xl overflow-hidden shadow-md">
            <img
              src="../assets/images/MHS_9.jpg"
              alt="Planning"
              class="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>

      <!-- Text Content -->
      <div class="w-full lg:w-1/2 text-center lg:text-left">
        <p
          class="uppercase text-sm tracking-wider text-gray-400 font-semibold mb-2"
        >
          What makes us different?
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
          We bring <span class="text-yellow italic">solutions</span> to make
          life easier for our customers.
        </h2>

        <p class="text-gray-900 text-sm leading-relaxed mb-4 text-justify">
            We work with industry experts to build a strong, unified brand
            emphasizing excellence, integrity, and social impact across all
            operations. This enables us to provide our customers with seamless
            experiences that reflect the Mshel Group’s core values, ensuring
            that all stakeholders recognize Mshel as synonymous with quality and
            community support.
        </p>
        <p class="text-gray-900 text-sm leading-relaxed mb-4 text-justify">
            Mshel Group foster a culture of innovation and driving long-term
            growth that positively impacts the communities we serve and sets new
            industry standards. We prioritize sustainable development through
            innovative practices and strategic investments that enhance economic
            and social value.
        </p>

        <!-- Features -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-8 gap-x-10 text-left">
          <div>
            <h4 class="text-lg font-semibold text-gray-900">Creativity</h4>
            <p class="text-gray-500 text-sm mt-2">
              Sparking unique designs and crafting unique solutions for every industry.
            </p>
          </div>
          <div>
            <h4 class="text-lg font-semibold text-gray-900">
              Inovative Thinking
            </h4>
            <p class="text-gray-500 text-sm mt-2">
              Pioneering bold ideas while leading advancement in all sectors.
            </p>
          </div>
          <div>
            <h4 class="text-lg font-semibold text-gray-900">Rapid Solutions</h4>
            <p class="text-gray-500 text-sm mt-2">
              Swift, precise and effective response to challenges across all operations.
            </p>
          </div>
          <div>
            <h4 class="text-lg font-semibold text-gray-900">
              Top-Notch Support
            </h4>
            <p class="text-gray-500 text-sm mt-2">
              Dedicated experts, delivering exceptional care for every client's need.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Meet Us section -->
   <boardDirectors />
   <managementTeam />
   <ourVision />
</template>

<script>
import boardDirectors from "../components/boardDirectors.vue";
import managementTeam from "../components/managementTeam.vue";
import ourVision from "../components/ourVision.vue";

export default {
    components: {
        boardDirectors,
        managementTeam,
        ourVision
    }
};
</script>

<style scoped></style>
